module.exports = "/images/vendor/flag-icon-css/flags/4x3/vg.svg?b37358a1a76ab385e4ea28f3732b7f57";